import { CompletePaymentResult } from "@loaders/completePaymentLoader"
import { AsyncErrorPage } from "@pages/ErrorPage"
import LoadingPage from "@pages/LoadingPage"
import { Suspense, useEffect } from "react"
import {
  Await,
  Navigate,
  useLoaderData,
  useSearchParams,
} from "react-router-dom"
import { Plan } from "src/types"

export default function PaymentCompletionPage() {
  const data = useLoaderData() as {
    completed: Promise<CompletePaymentResult>
  }

  const [searchParams] = useSearchParams()

  const amount = searchParams.get("amount")!
  const currency = searchParams.get("currency")!
  const paymentIntentClientSecret = searchParams.get(
    "payment_intent_client_secret",
  )!
  const fullPrice = searchParams.get("full_price")!
  const nextPriceId = searchParams.get("next_price_id")!
  const plan = searchParams.get("plan")! as Plan
  const priceId = searchParams.get("price_id")!
  const subscriptionId = searchParams.get("subscription_id")!

  const paymentPath = `/checkout/payment?amount=${amount}&currency=${currency}&client_secret=${paymentIntentClientSecret}&full_price=${fullPrice}&next_price_id=${nextPriceId}&plan=${plan}&price_id=${priceId}&subscription_id=${subscriptionId}`

  useEffect(() => {
    const timeout = setTimeout(() => {
      // NOTE: Just wait one second to let the Facebook Pixel do its job
    }, 1000)

    return () => {
      clearTimeout(timeout)
    }
  }, [])

  return (
    <Suspense fallback={<LoadingPage />}>
      <Await errorElement={<AsyncErrorPage />} resolve={data.completed}>
        {(completed: CompletePaymentResult) =>
          completed === "pending" ? (
            // NOTE: The payment page waits for the payment (it doesn't come
            // back here until it succeeded).
            <Navigate replace to={paymentPath} />
          ) : typeof completed === "object" ? (
            <Navigate replace to={completed.signInPath} />
          ) : completed ? (
            <Navigate to="/account/subscription" />
          ) : (
            <Navigate to={paymentPath} />
          )
        }
      </Await>
    </Suspense>
  )
}
